export const testIds = {
  "button-component": "button-component",
  "heading-component": "heading-component",
  "input-component": "input-component",
  "checkbox-component": "checkbox-component",
  "container-component": "container-component",
  "card-component": "card-component",
  "fileSelect-component": "fileSelect-component",
  "fileSelect-cross-component": "fileSelect-cross-component",
  "menuButton-component": "menuButton-component",
  "menuButton-open-toggle": "menuButton-open-toggle",
  "menuButton-option": "menuButton-option",
  "paragraph-component": "paragraph-component",
  "dashboard-navigation": "dashboard-navigation",
  "dashboard-card-navigation": "dashboard-card-navigation",
  "dashboard-card": "dashboard-card",
  "header-component": "header-component",
  "toggle-open-btn": "toggle-open-btn",
  "logout-btn": "logout-btn",
  "navigate-dashboard": "navigate-dashboard",
  "dropdown-label": "dropdown-label",
  "dropdown-component": "dropdown-component",
  "modal-link": "modal-link",
  "listFilter-input": "listFilter-input",
  "listFilter-wrapper": "listFilter-wrapper",
  "input-container": "input-container",
  "toolTip-component": "toolTip-component",
  "toolTip-content": "toolTip-content",
  "bulk-upload-page": "bulk-upload-page",
  "bulk-upload-back-btn": "bulk-upload-back-btn",
  "bulk-header": "bulk-header",
  "radio-input": "radio-input",
  "download-modal-bulk": "download-modal-bulk",
  "table-component": "table-component",
  "inactive-base": "inactive-base",
  "partner-details": "partner-details",
  "under-maintainance": "under-maintainance",
  "user-info": "user-info",
  "map-component": "map-component",
  "toogle-item": "toogle-item",
  "custom-calender-wrapper": "custom-calender-wrapper",
  "custom-calender-day": "custom-calender-day",
  "modal-container": "modal-container",
  "custom-calender-details": "custom-calender-details",
  "base-component": "base-component",
  "base-component-legends": "base-component-legends",
  "analytics-info": "analytics-info",
  "download-record": "download-record",
  "table-filter-component": "table-filter-component",
  "table-filter-icon": "table-filter-icon",
  "table-filter-pop-up": "table-filter-pop-up",
  "table-filter-remove": "table-filter-remove",
  "table-selected-filter-wrapper": "table-selected-filter-wrapper",
  "list-component": "list-component",
  "add-members-page": "add-members-page",
  "active-inactive-component": "active-inactive-component",
  "active-inactive-component-body": "active-inactive-component-body",
  "partner-card-wrapper": "partner-card-wrapper",
  "earning-component": "earning-component",
  "Update-City-PopId-Component": "Update-City-PopId-Component",
  "master-config-list-component": "master-config-list-component",
  "master-config-list-box": "master-config-list-box",
  "master-config-list-search-box": "master-config-list-search-box",
  "master-config-list-search-input": "master-config-list-search-input",
  "master-config-list-selected-data": "master-config-list-selected-data",
  "master-config-list-cross-icon": "master-config-list-cross-icon",
  "master-config-list": "master-config-list",
  "master-config-list-row-data": "master-config-list-row-data",
  "master-config-list-row-update": "master-config-list-row-data",
  "type-ahead-component": "type-ahead-component",
  "add-members-form": "add-members-form",
  "image-capture-dialog": "image-capture-dialog",
  "close-image-modal": "close-image-modal",
  "image-capture": "image-capture",
  "capture-image-input": "capture-image-input",
  "change-password-component": "change-password-component",
  "my-profile-component": "my-profile-component",
  "my-profile-component-document": "my-profile-component-document",
  "bulk-upload-file-format": "bulk-upload-file-format",
  "type-ahead-add-data": "type-ahead-add-data",
  "type-ahead-remove-data": "type-ahead-remove-data",
  "dashboard-detail-component": "dashboard-detail-component",
  "fileUplpoad-component": "fileUplpoad-component",
  "fileUpload-cross-icons": "fileUpload-cross-icons",
  "fileUplpoad-component-wrapper": "fileUplpoad-component-wrapper",
  "add-insurance-wrapper": "add-insurance-wrapper",
  "select-insurance-type": "select-insurance-type",
  "delete-user-wrapper": "delete-user-wrapper",
  "manage-team-wrapper": "manage-team-wrapper",
  "policy-verification-list": "policy-verification-list",
  "sub-partner-list": "sub-partner-list",
  "policy-details": "policy-details",
  "rejection-reason-dialog": "rejection-reason-dialog",
  "edit-members-form": "edit-members-form",
  "edit-details-btn": "edit-details-btn",
  "mandate-html": 'mandate-html',
  "prospect-evaluation-wrapper": "prospect-evaluation-wrapper",
  "add-prospect-button": "add-prospect-button",
  "partner-dashboard-detail": "partner-dashboard-detail",
  "contract-sign": "contract-sign",
  "add-prospect-wrapper": "add-prospect-wrapper",
  "e-card-wrapper": "e-card-wrapper",
  "prospect-template-wrapper": "prospect-template-wrapper",
  "prospect-template-next": "prospect-template-next",
  "prospect-info-modal-wrapper": "prospect-info-modal-wrapper",
  "prospect-form-wrapper": "prospect-form-wrapper",
  "prospect-evaluate-wrapper": "prospect-evaluate-wrapper",
  "prospect-info-wrapper": "prospect-info-wrapper",
  "order-installments-wrapper": "order-installments-wrapper",
  "order-details-wrapper": "order-details-wrapper",
  "manage-invoices-wrapper": "manage-invoices-wrapper",
  "manage-invoices-stats": "manage-invoices-stats",
  "manage-order-wrapper": "manage-order-wrapper",
  "monthy-view-wrapper": "monthy-view-wrapper",
  "yearly-view-wrapper": "yearly-view-wrapper",
  "safety-compliance-header": "safety-compliance-header",
  "safety-compliance-modal-head": "safety-compliance-modal-head",
  "view-queries-modal": "view-queries-modal",
  "product-view-wrapper": "product-view-wrapper",
  "range-slider-wrapper": "range-slider-wrapper",
  "multi-checkbox-component": "multi-checkbox-component",
  "catelog-filter-wrapper": "catelog-filter-wrapper",
  "color-selection-wrapper": "color-selection-wrapper",
  "product-catalog-wrapper": "product-catalog-wrapper",
  "custom-dropdown-wrapper": "custom-dropdown-wrapper",
  "custom-dropdown-input-box": "custom-dropdown-input-box",
  "custom-dropdown-option": "custom-dropdown-option",
  "product-listing-wrapper": "product-listing-wrapper",
  "master-category-page": "master-category-page",
  "scm-cart-wrapper": "scm-cart-wrapper",
  "scm-quantity-wrapper": "scm-quantity-wrapper",
  "scm-header-component": "scm-header-component",
  "scm-header-profile-section": "scm-header-profile-section",
  "scm-profile-component": "scm-profile-component",
};
